import axios from 'axios';

const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:3041';

/**
 * Axios instance configured for the Tambola API.
 * - Base URL from environment
 * - Credentials included (httpOnly cookies)
 * - JSON content type
 * - Response interceptor for error handling
 */
export const apiClient = axios.create({
  baseURL: `${API_BASE_URL}/api/v1`,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 10000,
});

// Response interceptor
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // TODO: Handle unauthorized - redirect to login
      console.warn('Unauthorized request');
    }
    return Promise.reject(error);
  },
);
